import styled from 'styled-components';

const Overflow = styled.div`
  overflow: hidden;
`;

export default Overflow;
